<template>
  <div class="modal fade" tabindex="-1">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
        ></button>
        <div class="modal-body">
          <slot></slot>

          <div
            v-if="variant !== 'scroll' && !customFooter"
            class="modal-footer btn-area"
          >
            <button
              v-if="variant !== 'caution'"
              type="button"
              class="btn btn-cancel"
              data-bs-dismiss="modal"
            >
              キャンセル
            </button>

            <button
              type="button"
              :class="`btn ${labelClass}`"
              @click="submitAction"
            >
              {{ label }}
            </button>

            <button
              v-if="variant === 'caution'"
              type="button"
              class="btn btn-cancel"
              data-bs-dismiss="modal"
            >
              キャンセル
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Modal",
  props: {
    // variant: [ normal, scroll, double, caution ]
    variant: {
      type: String,
      default: "normal",
    },
    customFooter: {
      type: Boolean,
      default: false,
    },
    submitLabel: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      label: "",
      labelClass: "btn-main",
    };
  },
  created() {
    if (!this.submitLabel) {
      if (this.variant === "normal" || this.variant === "double") {
        this.label = "登録する";
      }

      if (this.variant === "caution") {
        this.label = "削除する";
        this.labelClass = "btn-delete";
      }
    } else {
      this.label = this.successLabel;
    }
  },
  methods: {
    async submitAction() {
      this.$emit("submit");
    },
  },
};
</script>
